import {
  TEMPLATE_DELETE_TEMPLATE_BEGIN,
  TEMPLATE_DELETE_TEMPLATE_SUCCESS,
  TEMPLATE_DELETE_TEMPLATE_FAILURE,
  TEMPLATE_DELETE_TEMPLATE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function deleteTemplate(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: TEMPLATE_DELETE_TEMPLATE_BEGIN,
    });
    const { projectId, version, templateId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const config = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates/${templateId}`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: TEMPLATE_DELETE_TEMPLATE_SUCCESS,
            data: args.templateId,
          });
          toast.success('Deleted Successfully !', {});
          resolve(res);
        },
        (err) => {
          dispatch({
            type: TEMPLATE_DELETE_TEMPLATE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteTemplateError() {
  return {
    type: TEMPLATE_DELETE_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_DELETE_TEMPLATE_BEGIN:
      return {
        ...state,
        deleteTemplatePending: true,
        deleteTemplateError: null,
      };

    case TEMPLATE_DELETE_TEMPLATE_SUCCESS:
      return {
        ...state,
        deleteTemplatePending: false,
        deleteTemplateError: null,
        smsTemplates: state.smsTemplates.filter((e) => e.uuid !== action.data),
        mailTemplates: state.mailTemplates.filter((e) => e.uuid !== action.data),
        tooltipTemplates: state.tooltipTemplates.filter((e) => e.uuid !== action.data),
        agreementTemplates: state.agreementTemplates.filter((e) => e.uuid !== action.data),
        typesenseSearchTemplates: state.typesenseSearchTemplates.filter(
          (e) => e.uuid !== action.data,
        ),
        socketIoTemplates: state.socketIoTemplates.filter((e) => e.uuid !== action.data),
      };

    case TEMPLATE_DELETE_TEMPLATE_FAILURE:
      return {
        ...state,
        deleteTemplatePending: false,
        deleteTemplateError: action.data.error,
      };

    case TEMPLATE_DELETE_TEMPLATE_DISMISS_ERROR:
      return {
        ...state,
        deleteTemplateError: null,
      };

    default:
      return state;
  }
}
